(ns app.front.view.admin.commands.workspace-restore
  (:require [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.admin.entity-table :as entable]
            [app.front.view.group.admin.common :as acommon]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::state
  :-> ::state)

(rf/reg-event-db ::set-workspace-id
  (rf/path [::state])
  (fn [state [_ new-workspace-id]]
    (-> state
        (assoc :workspace-id new-workspace-id)
        (dissoc :workspace-data :workspace-restored))))

(rf/reg-sub ::workspace-id
  :<- [::state]
  (fn [state _] (:workspace-id state "")))

(rf/reg-sub ::workspace-id-valid?
  :<- [::workspace-id]
  (fn [workspace-id _]
    (nil? (workspace-model/check-workspace-id workspace-id))))

(rf/reg-event-fx ::get-workspace-for-restore
  (fn [_ [_ workspace-id]]
    {:comm/command {:command    :admin/get-workspace-for-restore
                    :method     :get
                    :data       (util/mmap workspace-id)
                    :on-success [::get-workspace-for-restore.success]}}))

(rf/reg-event-fx ::get-workspace-for-restore.success
  (fn [{:keys [db]} [_ _status resp]]
    {:db (-> db
             (assoc-in [::state :workspace-data] resp)
             (update ::state dissoc :workspace-restored))}))

(rf/reg-event-fx ::restore-workspace
  (fn [_ [_ workspace-id deletion-tx]]
    {:comm/command {:command    :admin/restore-workspace
                    :data       (util/mmap workspace-id deletion-tx)
                    :on-success [::restore-workspace.success]}}))

(rf/reg-event-fx ::restore-workspace.success
  (fn [{:keys [db]} [_ status resp]]
    {:db       (-> db
                   (assoc-in [::state :workspace-restored] true)
                   (update ::state dissoc :workspace-data))
     :dispatch [::entities/apply-changes status resp]}))

(rf/reg-sub ::workspace-data
  :<- [::state]
  :-> :workspace-data)

(rf/reg-sub ::workspace-restored
  :<- [::state]
  :-> :workspace-restored)

(defn help-text []
  [:section
   [:p "This tool allows you to " [:span.font-bold "restore"] " a workspace deleted with the admin delete tool. "
    [:span.font-bold "Use with extreme caution!"]]
   [:p "It restores database entities from Datomic history and automatically re-indexes the workspace in "
    "Elasticsearch so it becomes searchable again. " [:span.font-bold "File objects are not restored"] " by this tool: "
    "if the deletion already removed them from storage, they must be recovered separately from storage backups."]])

(defn- deleted-by-text [{:user/keys [username]}]
  (or username "-"))

(defn workspace-info []
  (when-some [workspace-data (<sub [::workspace-data])]
    (let [{{:workspace/keys [id municipal-case-id]} :workspace
           {:group/keys [name]}                     :authority-group
           deletion-tx                              :deletion-tx
           deleted-at                               :deleted-at
           deleted-by                               :deleted-by
           entity-count                             :entity-restore-count
           file-count                               :file-entity-count
           txes                                     :workspace-restore-txes} workspace-data
          title                                                              (str "Restore workspace " id)]
      [:<>
       [:div.flex.justify-start.flex-1
        (let [tr                  (<sub [:tr])
              trigger-button-text "Restore workspace"
              on-yes-click        #(>evt [::restore-workspace id deletion-tx])]
          [ui/modal-confirmation-button
           (util/mmap {:id "workspace-restore"} tr trigger-button-text on-yes-click)
           [:div
            [:p.bold (str "Are you sure you want to restore workspace " id "?")]
            [:p "This restores the database entities and re-indexes the workspace in Elasticsearch. File objects "
             "are not restored and must be recovered from storage backups if needed."]]])]
       [:section.bx--row.audit-log__tx
        [:div.audit-log__tx-header.bx--col-xs-12.flex-col.justify-between.items-baseline
         [:div.flex-0.mb-4 title]
         [:div.flex-0.mb-1 "Municipal case id: " (or municipal-case-id "-")]
         [:div.flex-0.mb-1 "Group: " name]
         [:div.flex-0.mb-1 "Deletion transaction: " deletion-tx]
         [:div.flex-0.mb-1 "Deleted at: " (str deleted-at)]
         [:div.flex-0.mb-1 "Deleted by: " (deleted-by-text deleted-by)]
         [:div.flex-0.mb-1 "Number of database entities to restore: " entity-count]
         [:div.flex-0.mt-4 "Number of file entities to verify in storage: " file-count]]
        [:div.audit-log__tx-changes.bx--col-xs-12
         [entable/entity-table
          {:id     (str "workspace-restore-txes" id)
           :title  title
           :datoms (map (fn [[op entity attribute value]]
                          {:entity    entity
                           :attribute attribute
                           :value     value
                           :added?    (= :db/add op)})
                        txes)
           :hidden #{}}]]]])))

(defn workspace-restored [workspace-id]
  (when (<sub [::workspace-restored])
    [:h5 (str "Workspace " workspace-id " restored and re-indexed. Verify file objects in storage separately.")]))

(defn wizard []
  (let [workspace-id (<sub [::workspace-id])]
    [:section
     [:h2 "Restore deleted workspace"]
     [:form.flex.items-end.mb-4
      {:on-submit (fn [ev]
                    (.preventDefault ev)
                    (>evt [::get-workspace-for-restore workspace-id]))}
      [ui/text-input
       {:id         "restore-workspace-id"
        :label-text "ID of the workspace to be restored"
        :on-change  #(rf/dispatch-sync [::set-workspace-id (futil/tval %)])
        :value      workspace-id}]
      [:div.ml-2
       (cc/button
         {:type     :submit
          :disabled (not (<sub [::workspace-id-valid?]))}
         "Find deleted workspace")]]
     [workspace-info]
     [workspace-restored workspace-id]]))

(defn view [match]
  [acommon/admin-page
   (util/mmap {:title "Restore deleted workspace"} match)
   [help-text]
   [wizard]])

(def route
  {:name :view/admin.commands.workspace-restore
   :view view})
